import { defineComponent as _defineComponent } from 'vue'
import { ArticleV1, ArticleContentMetaV2} from '@ilteducation/content-registry-types';
import { generateSummary } from '@/data-provider/aiService';
import eventBus from '@/foundations/services/eventBus';

type Props = {
  item: ArticleV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleSummaryForm',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: ArticleV1;
}



const createSummary = async () => {
  await generateSummary(props.item);
  eventBus.$emit('snackbar.open', `Summary generation started for article ${props.item.id} `);
};

const isArticleContentMetaV2 = (val: any): val is ArticleContentMetaV2 => val !== undefined && val.path !== undefined;


return { __sfc: true,props, createSummary, isArticleContentMetaV2 }
}

})